import { Theme, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import React, { FC, PropsWithChildren } from 'react';

import { GlobalStyle, StatusLabelStyle } from 'src/styles/GlobalStyles';
import { theme as defaultTheme } from 'src/styles/theme';

export const ThemeProvider: FC<PropsWithChildren<{ theme?: Theme }>> = ({ theme = defaultTheme, children }) => (
  <>
    <GlobalStyle theme={theme} />
    <MuiThemeProvider theme={theme}>
      <>
        <StatusLabelStyle />
        {children}
      </>
    </MuiThemeProvider>
  </>
);
